import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TypeActionDiscountEvent } from "../actionDiscountEvent";
export var epicDiscountEventSelectEvent = function (action$) {
    return action$.pipe(ofType(TypeActionDiscountEvent.SelectEvent), switchMap(function (action) {
        return from([actionModalOpen(IdModal.DiscountEvent)]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/discount-event/epics/epicDiscountEventSelectEvent.ts
// module id = 1832
// module chunks = 3